export enum DspType {
	Peq = 'peq',
	Eq = 'eq',
	Compressor = 'comp',
	Limiter = 'limiter',
	Delay = 'delay',
	Agc = 'agc',
	Aec = 'aec',
	Nr = 'nr',
	SignalGenerator = 'signal-generator'
}
